__turbopack_context__.v({
  "footerAccordianButton": "SuJP_G_footerAccordianButton",
  "footerAppBadges": "SuJP_G_footerAppBadges",
  "footerAppDownload": "SuJP_G_footerAppDownload",
  "footerAppDownloadDesktopContainer": "SuJP_G_footerAppDownloadDesktopContainer",
  "footerAppDownloadSocialBadges": "SuJP_G_footerAppDownloadSocialBadges",
  "footerAppDownloadText": "SuJP_G_footerAppDownloadText",
  "footerAppSocialContainer": "SuJP_G_footerAppSocialContainer",
  "footerAppSocialRow": "SuJP_G_footerAppSocialRow",
  "footerColumn": "SuJP_G_footerColumn",
  "footerColumnDesktopContainer": "SuJP_G_footerColumnDesktopContainer",
  "footerColumnMobileContainer": "SuJP_G_footerColumnMobileContainer",
  "footerColumnTitle": "SuJP_G_footerColumnTitle",
  "footerCookieButton": "SuJP_G_footerCookieButton",
  "footerLink": "SuJP_G_footerLink",
  "footerLinkWrapper": "SuJP_G_footerLinkWrapper",
  "footerLocalisationContainer": "SuJP_G_footerLocalisationContainer",
  "footerLowerContainer": "SuJP_G_footerLowerContainer",
  "footerLowerContent": "SuJP_G_footerLowerContent",
  "footerLowerDesktopColumn": "SuJP_G_footerLowerDesktopColumn",
  "footerQRCodeContainer": "SuJP_G_footerQRCodeContainer",
  "footerQRCodeText": "SuJP_G_footerQRCodeText",
  "footerSocialColumn": "SuJP_G_footerSocialColumn",
  "footerUpperContainer": "SuJP_G_footerUpperContainer",
  "footerUpperContent": "SuJP_G_footerUpperContent",
  "selectLanguage": "SuJP_G_selectLanguage",
  "selectLocation": "SuJP_G_selectLocation",
  "socialBadges": "SuJP_G_socialBadges",
  "socialLink": "SuJP_G_socialLink",
  "socialListItem": "SuJP_G_socialListItem",
});
